import clsx from 'clsx'

export function List({ className, ...props }) {
  return (
    <dl
      {...props}
      className={clsx(
        className,
        'grid grid-cols-1 pb-8'
      )}
    />
  )
}

export function Item({ className, ...props }) {
  return (
    <dt
      {...props}
      className={clsx(
        className,
        'col-start-1 border-t border-zinc-950/5 pt-3 first:border-none sm:border-t sm:border-zinc-950/5 sm:py-3 dark:border-white/5 sm:dark:border-white/5'
      )}
    />
  )
}
